import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { Overlay } from '@angular/cdk/overlay';
import {
  MAT_LEGACY_AUTOCOMPLETE_SCROLL_STRATEGY as MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
  MatLegacyAutocompleteModule,
} from '@angular/material/legacy-autocomplete';
import { TsButtonModule } from 'tsui';
import { TsDialogComponent } from 'tsui/lib/ts-dialog/ts-dialog.component';
import { AddLinkToCustomObjectValueDialog } from './add-link-to-custom-object-value.component';
import { MatLegacyOptionModule } from '@angular/material/legacy-core';
import { DirectivesModule } from '@shared/directives/directives.module';
import { FormFieldsModule } from '@shared/components/form-fields/form-fields.module';
import { AlertBannerComponent } from '@shared/components/widgets/alert-banner/alert-banner.component';

@NgModule({
  declarations: [AddLinkToCustomObjectValueDialog],
  exports: [AddLinkToCustomObjectValueDialog],
  imports: [
    TsDialogComponent,
    MatLegacyFormFieldModule,
    MatLegacyAutocompleteModule,
    FormsModule,
    ReactiveFormsModule,
    MatLegacyOptionModule,
    MatLegacyInputModule,
    DirectivesModule,
    MatDividerModule,
    TsButtonModule,
    FormFieldsModule,
    MatLegacySelectModule,
    AlertBannerComponent,
  ],
  providers: [
    {
      provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
      useFactory: (overlay: Overlay) => {
        return () => overlay.scrollStrategies.block();
      },
      deps: [Overlay],
    },
  ],
})
export class AddLinkToCustomObjectValueModule {}
